(function () {
    'use strict';

    angular
        .module('trainingRoster')
        .controller('TrainingAutomationSummaryCtrl', TrainingAutomationSummaryCtrl);

    function TrainingAutomationSummaryCtrl($uibModalInstance, modalParams, MessageService,$timeout) {
        var vm = this;

        vm.model = {
            title:'Training Automation Summary',
            message:[],
            params:{},
            trainingSummary:modalParams.dataList,
            cycle:modalParams.cycle
        };

       
        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };

    }
}());